export const verboall = [
  { port: "ir", rus: "идти", link: "https://www.conjugacao.com.br/verbo-ir/" },
  {
    port: "ser",
    rus: "быть",
    link: "https://www.conjugacao.com.br/verbo-ser/",
  },
  {
    port: "fazer",
    rus: "делать",
    link: "https://www.conjugacao.com.br/verbo-fazer/",
  },
  {
    port: "ter",
    rus: "иметь",
    link: "https://www.conjugacao.com.br/verbo-ter/",
  },
  {
    port: "ver",
    rus: "видеть",
    link: "https://www.conjugacao.com.br/verbo-ver/",
  },
  {
    port: "vir",
    rus: "приезжать",
    link: "https://www.conjugacao.com.br/verbo-vir/",
  },
  {
    port: "estar",
    rus: "быть",
    link: "https://www.conjugacao.com.br/verbo-estar/",
  },
  {
    port: "amar",
    rus: "любить",
    link: "https://www.conjugacao.com.br/verbo-amar/",
  },
  {
    port: "poder",
    rus: "мочь",
    link: "https://www.conjugacao.com.br/verbo-poder/",
  },
  {
    port: "dar",
    rus: "дать",
    link: "https://www.conjugacao.com.br/verbo-dar/",
  },
  {
    port: "haver",
    rus: "быть",
    link: "https://www.conjugacao.com.br/verbo-haver/",
  },
  {
    port: "pôr",
    rus: "ставить",
    link: "https://www.conjugacao.com.br/verbo-pôr/",
  },
  {
    port: "comer",
    rus: "есть",
    link: "https://www.conjugacao.com.br/verbo-comer/",
  },
  {
    port: "querer",
    rus: "хотеть",
    link: "https://www.conjugacao.com.br/verbo-querer/",
  },
  {
    port: "partir",
    rus: "убывать",
    link: "https://www.conjugacao.com.br/verbo-partir/",
  },
  {
    port: "falar",
    rus: "говорить",
    link: "https://www.conjugacao.com.br/verbo-falar/",
  },
  {
    port: "trazer",
    rus: "приносить",
    link: "https://www.conjugacao.com.br/verbo-trazer/",
  },
  {
    port: "estudar",
    rus: "учить",
    link: "https://www.conjugacao.com.br/verbo-estudar/",
  },
  {
    port: "cantar",
    rus: "петь",
    link: "https://www.conjugacao.com.br/verbo-cantar/",
  },
  {
    port: "dizer",
    rus: "сказать",
    link: "https://www.conjugacao.com.br/verbo-dizer/",
  },
  {
    port: "sair",
    rus: "выходить",
    link: "https://www.conjugacao.com.br/verbo-sair/",
  },
  {
    port: "ler",
    rus: "читать",
    link: "https://www.conjugacao.com.br/verbo-ler/",
  },
  {
    port: "saber",
    rus: "знать",
    link: "https://www.conjugacao.com.br/verbo-saber/",
  },
  {
    port: "rir",
    rus: "смеяться",
    link: "https://www.conjugacao.com.br/verbo-rir/",
  },
  {
    port: "correr",
    rus: "бегать",
    link: "https://www.conjugacao.com.br/verbo-correr/",
  },
  {
    port: "dormir",
    rus: "спать",
    link: "https://www.conjugacao.com.br/verbo-dormir/",
  },
  {
    port: "vender",
    rus: "продавать",
    link: "https://www.conjugacao.com.br/verbo-vender/",
  },
  {
    port: "beber",
    rus: "пить",
    link: "https://www.conjugacao.com.br/verbo-beber/",
  },
  {
    port: "pedir",
    rus: "просить",
    link: "https://www.conjugacao.com.br/verbo-pedir/",
  },
  {
    port: "escrever",
    rus: "писать",
    link: "https://www.conjugacao.com.br/verbo-escrever/",
  },
  {
    port: "andar",
    rus: "ходить",
    link: "https://www.conjugacao.com.br/verbo-andar/",
  },
  {
    port: "sorrir",
    rus: "улыбаться",
    link: "https://www.conjugacao.com.br/verbo-sorrir/",
  },
  {
    port: "ouvir",
    rus: "слышать",
    link: "https://www.conjugacao.com.br/verbo-ouvir/",
  },
  {
    port: "sentir",
    rus: "чувствовать",
    link: "https://www.conjugacao.com.br/verbo-sentir/",
  },
  {
    port: "ficar",
    rus: "оставаться, находиться",
    link: "https://www.conjugacao.com.br/verbo-ficar/",
  },
  {
    port: "chegar",
    rus: "прибывать",
    link: "https://www.conjugacao.com.br/verbo-chegar/",
  },
  {
    port: "agir",
    rus: "действовать",
    link: "https://www.conjugacao.com.br/verbo-agir/",
  },
  {
    port: "gostar",
    rus: "нравиться",
    link: "https://www.conjugacao.com.br/verbo-gostar/",
  },
  {
    port: "brincar",
    rus: "играть",
    link: "https://www.conjugacao.com.br/verbo-brincar/",
  },
  {
    port: "abrir",
    rus: "открывать",
    link: "https://www.conjugacao.com.br/verbo-abrir/",
  },
  {
    port: "caber",
    rus: "соответствовать",
    link: "https://www.conjugacao.com.br/verbo-caber/",
  },
  {
    port: "viver",
    rus: "жить",
    link: "https://www.conjugacao.com.br/verbo-viver/",
  },
  {
    port: "conseguir",
    rus: "мочь",
    link: "https://www.conjugacao.com.br/verbo-conseguir/",
  },
  {
    port: "comprar",
    rus: "покупать",
    link: "https://www.conjugacao.com.br/verbo-comprar/",
  },
  {
    port: "jogar",
    rus: "играть",
    link: "https://www.conjugacao.com.br/verbo-jogar/",
  },
  {
    port: "cair",
    rus: "падать",
    link: "https://www.conjugacao.com.br/verbo-cair/",
  },
  {
    port: "perder",
    rus: "терять",
    link: "https://www.conjugacao.com.br/verbo-perder/",
  },
  {
    port: "manter",
    rus: "поддерживать",
    link: "https://www.conjugacao.com.br/verbo-manter/",
  },
  {
    port: "corrigir",
    rus: "исправлять",
    link: "https://www.conjugacao.com.br/verbo-corrigir/",
  },
  {
    port: "passar",
    rus: "проводить, тратить",
    link: "https://www.conjugacao.com.br/verbo-passar/",
  },
  {
    port: "receber",
    rus: "получать",
    link: "https://www.conjugacao.com.br/verbo-receber/",
  },
  {
    port: "viajar",
    rus: "путешествовать",
    link: "https://www.conjugacao.com.br/verbo-viajar/",
  },
  {
    port: "pensar",
    rus: "думать",
    link: "https://www.conjugacao.com.br/verbo-pensar/",
  },
  {
    port: "conhecer",
    rus: "знать",
    link: "https://www.conjugacao.com.br/verbo-conhecer/",
  },
  {
    port: "assistir",
    rus: "посещать",
    link: "https://www.conjugacao.com.br/verbo-assistir/",
  },
  {
    port: "aprender",
    rus: "учить",
    link: "https://www.conjugacao.com.br/verbo-aprender/",
  },
  {
    port: "dançar",
    rus: "танцевать",
    link: "https://www.conjugacao.com.br/verbo-dançar/",
  },
  {
    port: "começar",
    rus: "начинать",
    link: "https://www.conjugacao.com.br/verbo-começar/",
  },
  {
    port: "intervir",
    rus: "вмешаться",
    link: "https://www.conjugacao.com.br/verbo-intervir/",
  },
  {
    port: "seguir",
    rus: "следовать",
    link: "https://www.conjugacao.com.br/verbo-seguir/",
  },
  {
    port: "trabalhar",
    rus: "работать",
    link: "https://www.conjugacao.com.br/verbo-trabalhar/",
  },
  {
    port: "crer",
    rus: "полагать",
    link: "https://www.conjugacao.com.br/verbo-crer/",
  },
  {
    port: "encontrar",
    rus: "находить, встречать",
    link: "https://www.conjugacao.com.br/verbo-encontrar/",
  },
  {
    port: "precisar",
    rus: "нуждаться",
    link: "https://www.conjugacao.com.br/verbo-precisar/",
  },
  {
    port: "deixar",
    rus: "покидать, оставлять",
    link: "https://www.conjugacao.com.br/verbo-deixar/",
  },
  {
    port: "dividir",
    rus: "делить",
    link: "https://www.conjugacao.com.br/verbo-dividir/",
  },
  {
    port: "levar",
    rus: "брать",
    link: "https://www.conjugacao.com.br/verbo-levar/",
  },
  {
    port: "dever",
    rus: "должен",
    link: "https://www.conjugacao.com.br/verbo-dever/",
  },
  {
    port: "colorir",
    rus: "раскрашивать",
    link: "https://www.conjugacao.com.br/verbo-colorir/",
  },
  {
    port: "voltar",
    rus: "возвращаться",
    link: "https://www.conjugacao.com.br/verbo-voltar/",
  },
  {
    port: "chamar",
    rus: "звать",
    link: "https://www.conjugacao.com.br/verbo-chamar/",
  },
  {
    port: "voar",
    rus: "летать",
    link: "https://www.conjugacao.com.br/verbo-voar/",
  },
  {
    port: "subir",
    rus: "подниматься",
    link: "https://www.conjugacao.com.br/verbo-subir/",
  },
  {
    port: "pular",
    rus: "прыгать",
    link: "https://www.conjugacao.com.br/verbo-pular/",
  },
  {
    port: "entender",
    rus: "понимать",
    link: "https://www.conjugacao.com.br/verbo-entender/",
  },
  {
    port: "passear",
    rus: "гулять",
    link: "https://www.conjugacao.com.br/verbo-passear/",
  },
  {
    port: "fugir",
    rus: "сбежать",
    link: "https://www.conjugacao.com.br/verbo-fugir/",
  },
  {
    port: "expor",
    rus: "разоблачать",
    link: "https://www.conjugacao.com.br/verbo-expor/",
  },
  {
    port: "nascer",
    rus: "родиться",
    link: "https://www.conjugacao.com.br/verbo-nascer/",
  },
  {
    port: "compor",
    rus: "сочинять",
    link: "https://www.conjugacao.com.br/verbo-compor/",
  },
  {
    port: "olhar",
    rus: "смотреть",
    link: "https://www.conjugacao.com.br/verbo-olhar/",
  },
  {
    port: "parar",
    rus: "остановиться",
    link: "https://www.conjugacao.com.br/verbo-parar/",
  },
  {
    port: "achar",
    rus: "думать",
    link: "https://www.conjugacao.com.br/verbo-achar/",
  },
  {
    port: "valer",
    rus: "стоить",
    link: "https://www.conjugacao.com.br/verbo-valer/",
  },
  {
    port: "usar",
    rus: "использовать",
    link: "https://www.conjugacao.com.br/verbo-usar/",
  },
  {
    port: "lembrar",
    rus: "запомнить",
    link: "https://www.conjugacao.com.br/verbo-lembrar/",
  },
  {
    port: "medir",
    rus: "измерять",
    link: "https://www.conjugacao.com.br/verbo-medir/",
  },
  {
    port: "dirigir",
    rus: "управлять, направлять",
    link: "https://www.conjugacao.com.br/verbo-dirigir/",
  },
  {
    port: "reaver",
    rus: "восстанавливать",
    link: "https://www.conjugacao.com.br/verbo-reaver/",
  },
  {
    port: "esquecer",
    rus: "забывать",
    link: "https://www.conjugacao.com.br/verbo-esquecer/",
  },
  {
    port: "morar",
    rus: "жить",
    link: "https://www.conjugacao.com.br/verbo-morar/",
  },
  {
    port: "acordar",
    rus: "просыпаться",
    link: "https://www.conjugacao.com.br/verbo-acordar/",
  },
  {
    port: "colocar",
    rus: "положить",
    link: "https://www.conjugacao.com.br/verbo-colocar/",
  },
  {
    port: "propor",
    rus: "предлагать",
    link: "https://www.conjugacao.com.br/verbo-propor/",
  },
  {
    port: "proteger",
    rus: "защищать",
    link: "https://www.conjugacao.com.br/verbo-proteger/",
  },
  {
    port: "ganhar",
    rus: "зарабатывать, побеждать",
    link: "https://www.conjugacao.com.br/verbo-ganhar/",
  },
  {
    port: "feder",
    rus: "вонять",
    link: "https://www.conjugacao.com.br/verbo-feder/",
  },
  {
    port: "tomar",
    rus: "принимать",
    link: "https://www.conjugacao.com.br/verbo-tomar/",
  },
  {
    port: "requerer",
    rus: "требовать",
    link: "https://www.conjugacao.com.br/verbo-requerer/",
  },
  {
    port: "esperar",
    rus: "ждать",
    link: "https://www.conjugacao.com.br/verbo-esperar/",
  },
  {
    port: "conjugar",
    rus: "сопрягать",
    link: "https://www.conjugacao.com.br/verbo-conjugar/",
  },
  {
    port: "pegar",
    rus: "брать",
    link: "https://www.conjugacao.com.br/verbo-pegar/",
  },
  {
    port: "descer",
    rus: "спускаться",
    link: "https://www.conjugacao.com.br/verbo-descer/",
  },
  {
    port: "morrer",
    rus: "умереть",
    link: "https://www.conjugacao.com.br/verbo-morrer/",
  },
  {
    port: "entrar",
    rus: "входить",
    link: "https://www.conjugacao.com.br/verbo-entrar/",
  },
  {
    port: "fingir",
    rus: "подделать",
    link: "https://www.conjugacao.com.br/verbo-fingir/",
  },
  {
    port: "tossir",
    rus: "кашлять",
    link: "https://www.conjugacao.com.br/verbo-tossir/",
  },
  {
    port: "mexer",
    rus: "смешать",
    link: "https://www.conjugacao.com.br/verbo-mexer/",
  },
  {
    port: "contar",
    rus: "рассказывать",
    link: "https://www.conjugacao.com.br/verbo-contar/",
  },
  {
    port: "possuir",
    rus: "обладать",
    link: "https://www.conjugacao.com.br/verbo-possuir/",
  },
  {
    port: "ajudar",
    rus: "помогать",
    link: "https://www.conjugacao.com.br/verbo-ajudar/",
  },
  {
    port: "bater",
    rus: "быть",
    link: "https://www.conjugacao.com.br/verbo-bater/",
  },
  {
    port: "conversar",
    rus: "разговаривать",
    link: "https://www.conjugacao.com.br/verbo-conversar/",
  },
  {
    port: "cumprir",
    rus: "выполнить",
    link: "https://www.conjugacao.com.br/verbo-cumprir/",
  },
  {
    port: "mandar",
    rus: "отправлять",
    link: "https://www.conjugacao.com.br/verbo-mandar/",
  },
  {
    port: "chover",
    rus: "дождь идет",
    link: "https://www.conjugacao.com.br/verbo-chover/",
  },
  {
    port: "chorar",
    rus: "плакать",
    link: "https://www.conjugacao.com.br/verbo-chorar/",
  },
  {
    port: "preferir",
    rus: "предпочитать",
    link: "https://www.conjugacao.com.br/verbo-preferir/",
  },
  {
    port: "descobrir",
    rus: "обнаружить, открыть",
    link: "https://www.conjugacao.com.br/verbo-descobrir/",
  },
  {
    port: "continuar",
    rus: "продолжать",
    link: "https://www.conjugacao.com.br/verbo-continuar/",
  },
  {
    port: "suar",
    rus: "потеть",
    link: "https://www.conjugacao.com.br/verbo-suar/",
  },
  {
    port: "lavar",
    rus: "мыть",
    link: "https://www.conjugacao.com.br/verbo-lavar/",
  },
  {
    port: "doar",
    rus: "пожертвовать",
    link: "https://www.conjugacao.com.br/verbo-doar/",
  },
  {
    port: "acabar",
    rus: "заканчивать",
    link: "https://www.conjugacao.com.br/verbo-acabar/",
  },
  {
    port: "desejar",
    rus: "желать",
    link: "https://www.conjugacao.com.br/verbo-desejar/",
  },
  {
    port: "vestir",
    rus: "носить",
    link: "https://www.conjugacao.com.br/verbo-vestir/",
  },
  {
    port: "imprimir",
    rus: "печатать",
    link: "https://www.conjugacao.com.br/verbo-imprimir/",
  },
  {
    port: "existir",
    rus: "существовать",
    link: "https://www.conjugacao.com.br/verbo-existir/",
  },
  {
    port: "decidir",
    rus: "решать",
    link: "https://www.conjugacao.com.br/verbo-decidir/",
  },
  {
    port: "sonhar",
    rus: "мечтать",
    link: "https://www.conjugacao.com.br/verbo-sonhar/",
  },
  {
    port: "prever",
    rus: "предсказывать",
    link: "https://www.conjugacao.com.br/verbo-prever/",
  },
  {
    port: "conter",
    rus: "содержать",
    link: "https://www.conjugacao.com.br/verbo-conter/",
  },
  {
    port: "sumir",
    rus: "пропадать",
    link: "https://www.conjugacao.com.br/verbo-sumir/",
  },
  {
    port: "caminhar",
    rus: "гулять",
    link: "https://www.conjugacao.com.br/verbo-caminhar/",
  },
  {
    port: "pagar",
    rus: "платить",
    link: "https://www.conjugacao.com.br/verbo-pagar/",
  },
  {
    port: "dispor",
    rus: "разпоряжаться",
    link: "https://www.conjugacao.com.br/verbo-dispor/",
  },
  {
    port: "falir",
    rus: "обанкротиться",
    link: "https://www.conjugacao.com.br/verbo-falir/",
  },
  {
    port: "procurar",
    rus: "искать",
    link: "https://www.conjugacao.com.br/verbo-procurar/",
  },
  {
    port: "nadar",
    rus: "плавать",
    link: "https://www.conjugacao.com.br/verbo-nadar/",
  },
  {
    port: "construir",
    rus: "строить",
    link: "https://www.conjugacao.com.br/verbo-construir/",
  },
  {
    port: "divertir",
    rus: "веселиьтся",
    link: "https://www.conjugacao.com.br/verbo-divertir/",
  },
  {
    port: "prover",
    rus: "предоставлять",
    link: "https://www.conjugacao.com.br/verbo-prover/",
  },
  {
    port: "atender",
    rus: "встречаться",
    link: "https://www.conjugacao.com.br/verbo-atender/",
  },
  {
    port: "acontecer",
    rus: "случаться, происходить",
    link: "https://www.conjugacao.com.br/verbo-acontecer/",
  },
  {
    port: "mudar",
    rus: "изменять",
    link: "https://www.conjugacao.com.br/verbo-mudar/",
  },
  {
    port: "escolher",
    rus: "выбирать",
    link: "https://www.conjugacao.com.br/verbo-escolher/",
  },
  {
    port: "entreter",
    rus: "развлекать",
    link: "https://www.conjugacao.com.br/verbo-entreter/",
  },
  {
    port: "responder",
    rus: "ответить",
    link: "https://www.conjugacao.com.br/verbo-responder/",
  },
  {
    port: "aderir",
    rus: "присоединиться",
    link: "https://www.conjugacao.com.br/verbo-aderir/",
  },
  {
    port: "mentir",
    rus: "врать",
    link: "https://www.conjugacao.com.br/verbo-mentir/",
  },
  {
    port: "crescer",
    rus: "расти",
    link: "https://www.conjugacao.com.br/verbo-crescer/",
  },
  {
    port: "perdoar",
    rus: "простить",
    link: "https://www.conjugacao.com.br/verbo-perdoar/",
  },
  {
    port: "fechar",
    rus: "закрывать",
    link: "https://www.conjugacao.com.br/verbo-fechar/",
  },
  {
    port: "almoçar",
    rus: "обедать",
    link: "https://www.conjugacao.com.br/verbo-almoçar/",
  },
  {
    port: "enviar",
    rus: "отправлять",
    link: "https://www.conjugacao.com.br/verbo-enviar/",
  },
  {
    port: "desistir",
    rus: "сдаваться",
    link: "https://www.conjugacao.com.br/verbo-desistir/",
  },
  {
    port: "encher",
    rus: "заполнить",
    link: "https://www.conjugacao.com.br/verbo-encher/",
  },
  {
    port: "tornar",
    rus: "становиться",
    link: "https://www.conjugacao.com.br/verbo-tornar/",
  },
  {
    port: "participar",
    rus: "участвовать",
    link: "https://www.conjugacao.com.br/verbo-participar/",
  },
  {
    port: "parecer",
    rus: "казаться, быть похожим",
    link: "https://www.conjugacao.com.br/verbo-parecer/",
  },
  {
    port: "realizar",
    rus: "реализовать, выполнить",
    link: "https://www.conjugacao.com.br/verbo-realizar/",
  },
  {
    port: "servir",
    rus: "служить, подходить",
    link: "https://www.conjugacao.com.br/verbo-servir/",
  },
  {
    port: "vencer",
    rus: "победить",
    link: "https://www.conjugacao.com.br/verbo-vencer/",
  },
  {
    port: "ligar",
    rus: "включать, соединить, звонить",
    link: "https://www.conjugacao.com.br/verbo-ligar/",
  },
  {
    port: "permitir",
    rus: "разрешать",
    link: "https://www.conjugacao.com.br/verbo-permitir/",
  },
  {
    port: "avisar",
    rus: "предупреждать",
    link: "https://www.conjugacao.com.br/verbo-avisar/",
  },
  {
    port: "terminar",
    rus: "заканчивать",
    link: "https://www.conjugacao.com.br/verbo-terminar/",
  },
  {
    port: "sentar",
    rus: "сидеть",
    link: "https://www.conjugacao.com.br/verbo-sentar/",
  },
  {
    port: "demolir",
    rus: "снести, разрушить",
    link: "https://www.conjugacao.com.br/verbo-demolir/",
  },
  {
    port: "tirar",
    rus: "брать, снимать",
    link: "https://www.conjugacao.com.br/verbo-tirar/",
  },
  {
    port: "buscar",
    rus: "искать",
    link: "https://www.conjugacao.com.br/verbo-buscar/",
  },
  {
    port: "polir",
    rus: "полировать",
    link: "https://www.conjugacao.com.br/verbo-polir/",
  },
  {
    port: "apresentar",
    rus: "представлять",
    link: "https://www.conjugacao.com.br/verbo-apresentar/",
  },
  {
    port: "sofrer",
    rus: "страдать",
    link: "https://www.conjugacao.com.br/verbo-sofrer/",
  },
  {
    port: "entregar",
    rus: "доставлять",
    link: "https://www.conjugacao.com.br/verbo-entregar/",
  },
  {
    port: "criar",
    rus: "создавать",
    link: "https://www.conjugacao.com.br/verbo-criar/",
  },
  {
    port: "casar",
    rus: "жениться",
    link: "https://www.conjugacao.com.br/verbo-casar/",
  },
  {
    port: "levantar",
    rus: "вставать",
    link: "https://www.conjugacao.com.br/verbo-levantar/",
  },
  {
    port: "perceber",
    rus: "понимать, воспринимать",
    link: "https://www.conjugacao.com.br/verbo-perceber/",
  },
  {
    port: "impor",
    rus: "навязывать",
    link: "https://www.conjugacao.com.br/verbo-impor/",
  },
  {
    port: "ferir",
    rus: "повредить",
    link: "https://www.conjugacao.com.br/verbo-ferir/",
  },
  {
    port: "adquirir",
    rus: "приобретать",
    link: "https://www.conjugacao.com.br/verbo-adquirir/",
  },
  {
    port: "rever",
    rus: "пересмотреть",
    link: "https://www.conjugacao.com.br/verbo-rever/",
  },
  {
    port: "perguntar",
    rus: "спрашивать",
    link: "https://www.conjugacao.com.br/verbo-perguntar/",
  },
  {
    port: "repor",
    rus: "перезагрузить",
    link: "https://www.conjugacao.com.br/verbo-repor/",
  },
  {
    port: "agradecer",
    rus: "благодарить",
    link: "https://www.conjugacao.com.br/verbo-agradecer/",
  },
  {
    port: "adequar",
    rus: "подходить",
    link: "https://www.conjugacao.com.br/verbo-adequar/",
  },
  {
    port: "convidar",
    rus: "приглашать",
    link: "https://www.conjugacao.com.br/verbo-convidar/",
  },
  {
    port: "aceitar",
    rus: "принять",
    link: "https://www.conjugacao.com.br/verbo-aceitar/",
  },
  {
    port: "tentar",
    rus: "пытаться",
    link: "https://www.conjugacao.com.br/verbo-tentar/",
  },
  {
    port: "mostrar",
    rus: "показывать",
    link: "https://www.conjugacao.com.br/verbo-mostrar/",
  },
  {
    port: "deter",
    rus: "задерживать",
    link: "https://www.conjugacao.com.br/verbo-deter/",
  },
  {
    port: "ensinar",
    rus: "учить",
    link: "https://www.conjugacao.com.br/verbo-ensinar/",
  },
  {
    port: "odiar",
    rus: "ненавидеть",
    link: "https://www.conjugacao.com.br/verbo-odiar/",
  },
  {
    port: "acreditar",
    rus: "верить",
    link: "https://www.conjugacao.com.br/verbo-acreditar/",
  },
  {
    port: "informar",
    rus: "информировать",
    link: "https://www.conjugacao.com.br/verbo-informar/",
  },
  {
    port: "visitar",
    rus: "посетить",
    link: "https://www.conjugacao.com.br/verbo-visitar/",
  },
  {
    port: "pentear",
    rus: "расчесывать",
    link: "https://www.conjugacao.com.br/verbo-pentear/",
  },
  {
    port: "matar",
    rus: "убить",
    link: "https://www.conjugacao.com.br/verbo-matar/",
  },
  {
    port: "aparecer",
    rus: "появиться",
    link: "https://www.conjugacao.com.br/verbo-aparecer/",
  },
  {
    port: "obter",
    rus: "получить",
    link: "https://www.conjugacao.com.br/verbo-obter/",
  },
  {
    port: "aproveitar",
    rus: "наслаждаться",
    link: "https://www.conjugacao.com.br/verbo-aproveitar/",
  },
  {
    port: "beijar",
    rus: "целовать",
    link: "https://www.conjugacao.com.br/verbo-beijar/",
  },
  {
    port: "respeitar",
    rus: "уважать",
    link: "https://www.conjugacao.com.br/verbo-respeitar/",
  },
  {
    port: "resolver",
    rus: "решать",
    link: "https://www.conjugacao.com.br/verbo-resolver/",
  },
  {
    port: "tocar",
    rus: "принимать",
    link: "https://www.conjugacao.com.br/verbo-tocar/",
  },
  {
    port: "gritar",
    rus: "кричать",
    link: "https://www.conjugacao.com.br/verbo-gritar/",
  },
  {
    port: "supor",
    rus: "предполагать",
    link: "https://www.conjugacao.com.br/verbo-supor/",
  },
  {
    port: "incluir",
    rus: "включать ",
    link: "https://www.conjugacao.com.br/verbo-incluir/",
  },
  {
    port: "roer",
    rus: "грызть",
    link: "https://www.conjugacao.com.br/verbo-roer/",
  },
  {
    port: "zoar",
    rus: "шутить",
    link: "https://www.conjugacao.com.br/verbo-zoar/",
  },
  {
    port: "surgir",
    rus: "появиться",
    link: "https://www.conjugacao.com.br/verbo-surgir/",
  },
  {
    port: "compreender",
    rus: "понимать",
    link: "https://www.conjugacao.com.br/verbo-compreender/",
  },
  {
    port: "cobrir",
    rus: "покрывать",
    link: "https://www.conjugacao.com.br/verbo-cobrir/",
  },
  {
    port: "cuidar",
    rus: "заботиться",
    link: "https://www.conjugacao.com.br/verbo-cuidar/",
  },
  {
    port: "pintar",
    rus: "красить",
    link: "https://www.conjugacao.com.br/verbo-pintar/",
  },
  {
    port: "julgar",
    rus: "судить",
    link: "https://www.conjugacao.com.br/verbo-julgar/",
  },
  {
    port: "excluir",
    rus: "удалить",
    link: "https://www.conjugacao.com.br/verbo-excluir/",
  },
  {
    port: "discutir",
    rus: "обсуждать",
    link: "https://www.conjugacao.com.br/verbo-discutir/",
  },
  {
    port: "destruir",
    rus: "разрушать",
    link: "https://www.conjugacao.com.br/verbo-destruir/",
  },
  {
    port: "permanecer",
    rus: "оставаться ",
    link: "https://www.conjugacao.com.br/verbo-permanecer/",
  },
  {
    port: "escutar",
    rus: "слушать",
    link: "https://www.conjugacao.com.br/verbo-escutar/",
  },
  {
    port: "ceder",
    rus: "уступить",
    link: "https://www.conjugacao.com.br/verbo-ceder/",
  },
  {
    port: "oferecer",
    rus: "предлагать",
    link: "https://www.conjugacao.com.br/verbo-oferecer/",
  },
  {
    port: "preparar",
    rus: "готовить",
    link: "https://www.conjugacao.com.br/verbo-preparar/",
  },
  {
    port: "limpar",
    rus: "убирать",
    link: "https://www.conjugacao.com.br/verbo-limpar/",
  },
  {
    port: "repetir",
    rus: "повторять",
    link: "https://www.conjugacao.com.br/verbo-repetir/",
  },
  {
    port: "imaginar",
    rus: "представить",
    link: "https://www.conjugacao.com.br/verbo-imaginar/",
  },
  {
    port: "convir",
    rus: "соглашаться",
    link: "https://www.conjugacao.com.br/verbo-convir/",
  },
  {
    port: "competir",
    rus: "завершить",
    link: "https://www.conjugacao.com.br/verbo-competir/",
  },
  {
    port: "cortar",
    rus: "резать",
    link: "https://www.conjugacao.com.br/verbo-cortar/",
  },
  {
    port: "marcar",
    rus: "помечать, записываться",
    link: "https://www.conjugacao.com.br/verbo-marcar/",
  },
  {
    port: "analisar",
    rus: "анализировать",
    link: "https://www.conjugacao.com.br/verbo-analisar/",
  },
  {
    port: "salvar",
    rus: "спасать",
    link: "https://www.conjugacao.com.br/verbo-salvar/",
  },
  {
    port: "interagir",
    rus: "взаимодействовать",
    link: "https://www.conjugacao.com.br/verbo-interagir/",
  },
  {
    port: "adorar",
    rus: "нравиться",
    link: "https://www.conjugacao.com.br/verbo-adorar/",
  },
  {
    port: "prender",
    rus: "арестовать",
    link: "https://www.conjugacao.com.br/verbo-prender/",
  },
  {
    port: "reter",
    rus: "сохранить",
    link: "https://www.conjugacao.com.br/verbo-reter/",
  },
  {
    port: "reunir",
    rus: "собираться, встречаться",
    link: "https://www.conjugacao.com.br/verbo-reunir/",
  },
  {
    port: "roubar",
    rus: "украсть",
    link: "https://www.conjugacao.com.br/verbo-roubar/",
  },
  {
    port: "preocupar",
    rus: "волноваться",
    link: "https://www.conjugacao.com.br/verbo-preocupar/",
  },
  {
    port: "arrumar",
    rus: "прибираться",
    link: "https://www.conjugacao.com.br/verbo-arrumar/",
  },
  {
    port: "varrer",
    rus: "подметать",
    link: "https://www.conjugacao.com.br/verbo-varrer/",
  },
  {
    port: "plantar",
    rus: "посадить",
    link: "https://www.conjugacao.com.br/verbo-plantar/",
  },
  {
    port: "garantir",
    rus: "гарантировать",
    link: "https://www.conjugacao.com.br/verbo-garantir/",
  },
  {
    port: "virar",
    rus: "поворачивать",
    link: "https://www.conjugacao.com.br/verbo-virar/",
  },
  {
    port: "colher",
    rus: "собирать ",
    link: "https://www.conjugacao.com.br/verbo-colher/",
  },
  {
    port: "merecer",
    rus: "заслуживать",
    link: "https://www.conjugacao.com.br/verbo-merecer/",
  },
  {
    port: "observar",
    rus: "наблюдать",
    link: "https://www.conjugacao.com.br/verbo-observar/",
  },
  {
    port: "abraçar",
    rus: "обнимать",
    link: "https://www.conjugacao.com.br/verbo-abraçar/",
  },
  {
    port: "unir",
    rus: "объединять",
    link: "https://www.conjugacao.com.br/verbo-unir/",
  },
  {
    port: "ingerir",
    rus: "проглотить",
    link: "https://www.conjugacao.com.br/verbo-ingerir/",
  },
  {
    port: "lutar",
    rus: "бороться",
    link: "https://www.conjugacao.com.br/verbo-lutar/",
  },
  {
    port: "curtir",
    rus: "понравиться",
    link: "https://www.conjugacao.com.br/verbo-curtir/",
  },
  {
    port: "refletir",
    rus: "отражать",
    link: "https://www.conjugacao.com.br/verbo-refletir/",
  },
  {
    port: "compartilhar",
    rus: "делиться",
    link: "https://www.conjugacao.com.br/verbo-compartilhar/",
  },
  {
    port: "provir",
    rus: "приходить",
    link: "https://www.conjugacao.com.br/verbo-provir/",
  },
  {
    port: "iniciar",
    rus: "начинать",
    link: "https://www.conjugacao.com.br/verbo-iniciar/",
  },
  {
    port: "abolir",
    rus: "отменять",
    link: "https://www.conjugacao.com.br/verbo-abolir/",
  },
  {
    port: "sugerir",
    rus: "предлагать",
    link: "https://www.conjugacao.com.br/verbo-sugerir/",
  },
  {
    port: "opor",
    rus: "выступать против",
    link: "https://www.conjugacao.com.br/verbo-opor/",
  },
  {
    port: "diminuir",
    rus: "уменьшать",
    link: "https://www.conjugacao.com.br/verbo-diminuir/",
  },
  {
    port: "atingir",
    rus: "достигать",
    link: "https://www.conjugacao.com.br/verbo-atingir/",
  },
  {
    port: "exigir",
    rus: "требовать",
    link: "https://www.conjugacao.com.br/verbo-exigir/",
  },
  {
    port: "bloquear",
    rus: "блокировать",
    link: "https://www.conjugacao.com.br/verbo-bloquear/",
  },
  {
    port: "acompanhar",
    rus: "сопровождать",
    link: "https://www.conjugacao.com.br/verbo-acompanhar/",
  },
  {
    port: "soar",
    rus: "звучать",
    link: "https://www.conjugacao.com.br/verbo-soar/",
  },
  {
    port: "maquiar",
    rus: "составить",
    link: "https://www.conjugacao.com.br/verbo-maquiar/",
  },
  {
    port: "guardar",
    rus: "сохранять",
    link: "https://www.conjugacao.com.br/verbo-guardar/",
  },
  {
    port: "encaminhar",
    rus: "переслать",
    link: "https://www.conjugacao.com.br/verbo-encaminhar/",
  },
  {
    port: "cozinhar",
    rus: "варить",
    link: "https://www.conjugacao.com.br/verbo-cozinhar/",
  },
  {
    port: "caçar",
    rus: "охотиться",
    link: "https://www.conjugacao.com.br/verbo-caçar/",
  },
  {
    port: "despedir",
    rus: "увольнять",
    link: "https://www.conjugacao.com.br/verbo-despedir/",
  },
  {
    port: "explicar",
    rus: "объяснять",
    link: "https://www.conjugacao.com.br/verbo-explicar/",
  },
  {
    port: "concluir",
    rus: "заключать",
    link: "https://www.conjugacao.com.br/verbo-concluir/",
  },
  {
    port: "atrair",
    rus: "привлекать",
    link: "https://www.conjugacao.com.br/verbo-atrair/",
  },
  {
    port: "contribuir",
    rus: "способствовать",
    link: "https://www.conjugacao.com.br/verbo-contribuir/",
  },
  {
    port: "apoiar",
    rus: "поддерживать",
    link: "https://www.conjugacao.com.br/verbo-apoiar/",
  },
  {
    port: "magoar",
    rus: "причинять боль",
    link: "https://www.conjugacao.com.br/verbo-magoar/",
  },
  {
    port: "aguardar",
    rus: "ждать",
    link: "https://www.conjugacao.com.br/verbo-aguardar/",
  },
  {
    port: "contradizer",
    rus: "противоречить",
    link: "https://www.conjugacao.com.br/verbo-contradizer/",
  },
  {
    port: "defender",
    rus: "защищать",
    link: "https://www.conjugacao.com.br/verbo-defender/",
  },
  {
    port: "presentear",
    rus: "дарить подарки",
    link: "https://www.conjugacao.com.br/verbo-presentear/",
  },
  {
    port: "repartir",
    rus: "делиться",
    link: "https://www.conjugacao.com.br/verbo-repartir/",
  },
  {
    port: "ansiar",
    rus: "тосковать",
    link: "https://www.conjugacao.com.br/verbo-ansiar/",
  },
  {
    port: "ocorrer",
    rus: "происходить",
    link: "https://www.conjugacao.com.br/verbo-ocorrer/",
  },
  {
    port: "cansar",
    rus: "уставать",
    link: "https://www.conjugacao.com.br/verbo-cansar/",
  },
  {
    port: "distrair",
    rus: "отвлекать",
    link: "https://www.conjugacao.com.br/verbo-distrair/",
  },
  {
    port: "alcançar",
    rus: "достигать",
    link: "https://www.conjugacao.com.br/verbo-alcançar/",
  },
  {
    port: "lançar",
    rus: "бросать",
    link: "https://www.conjugacao.com.br/verbo-lançar/",
  },
  {
    port: "produzir",
    rus: "производить",
    link: "https://www.conjugacao.com.br/verbo-produzir/",
  },
  {
    port: "exercer",
    rus: "упражнение",
    link: "https://www.conjugacao.com.br/verbo-exercer/",
  },
  {
    port: "insistir",
    rus: "настаивать",
    link: "https://www.conjugacao.com.br/verbo-insistir/",
  },
  {
    port: "satisfazer",
    rus: "удовлетворить",
    link: "https://www.conjugacao.com.br/verbo-satisfazer/",
  },
  {
    port: "copiar",
    rus: "копировать",
    link: "https://www.conjugacao.com.br/verbo-copiar/",
  },
  {
    port: "utilizar",
    rus: "использовать",
    link: "https://www.conjugacao.com.br/verbo-utilizar/",
  },
  {
    port: "considerar",
    rus: "учитывать",
    link: "https://www.conjugacao.com.br/verbo-considerar/",
  },
  {
    port: "transformar",
    rus: "преобразовывать",
    link: "https://www.conjugacao.com.br/verbo-transformar/",
  },
  {
    port: "calar",
    rus: "замолчать",
    link: "https://www.conjugacao.com.br/verbo-calar/",
  },
  {
    port: "descansar",
    rus: "отдыхать",
    link: "https://www.conjugacao.com.br/verbo-descansar/",
  },
  {
    port: "faltar",
    rus: "скучать, пропускать",
    link: "https://www.conjugacao.com.br/verbo-faltar/",
  },
  {
    port: "tratar",
    rus: "иметь дело с, лечить",
    link: "https://www.conjugacao.com.br/verbo-tratar/",
  },
  {
    port: "esconder",
    rus: "прятаться",
    link: "https://www.conjugacao.com.br/verbo-esconder/",
  },
  {
    port: "apagar",
    rus: "выключать",
    link: "https://www.conjugacao.com.br/verbo-apagar/",
  },
  {
    port: "quebrar",
    rus: "сломать",
    link: "https://www.conjugacao.com.br/verbo-quebrar/",
  },
  {
    port: "abençoar",
    rus: "благословлять",
    link: "https://www.conjugacao.com.br/verbo-abençoar/",
  },
  {
    port: "errar",
    rus: "ошибаться",
    link: "https://www.conjugacao.com.br/verbo-errar/",
  },
  {
    port: "saltar",
    rus: "Прыгать",
    link: "https://www.conjugacao.com.br/verbo-saltar/",
  },
  {
    port: "indicar",
    rus: "указывать",
    link: "https://www.conjugacao.com.br/verbo-indicar/",
  },
  {
    port: "desenhar",
    rus: "проектировать, рисовать",
    link: "https://www.conjugacao.com.br/verbo-desenhar/",
  },
  {
    port: "confundir",
    rus: "смущать",
    link: "https://www.conjugacao.com.br/verbo-confundir/",
  },
  {
    port: "resistir",
    rus: "сопротивляться",
    link: "https://www.conjugacao.com.br/verbo-resistir/",
  },
  {
    port: "acender",
    rus: "загораться",
    link: "https://www.conjugacao.com.br/verbo-acender/",
  },
  {
    port: "praticar",
    rus: "практиковать",
    link: "https://www.conjugacao.com.br/verbo-praticar/",
  },
  {
    port: "conquistar",
    rus: "покорять",
    link: "https://www.conjugacao.com.br/verbo-conquistar/",
  },
  {
    port: "deitar",
    rus: "ложиться",
    link: "https://www.conjugacao.com.br/verbo-deitar/",
  },
  {
    port: "lidar",
    rus: "вести",
    link: "https://www.conjugacao.com.br/verbo-lidar/",
  },
  {
    port: "conduzir",
    rus: "водить",
    link: "https://www.conjugacao.com.br/verbo-conduzir/",
  },
  {
    port: "negar",
    rus: "отрицать",
    link: "https://www.conjugacao.com.br/verbo-negar/",
  },
  {
    port: "reagir",
    rus: "реагировать",
    link: "https://www.conjugacao.com.br/verbo-reagir/",
  },
  {
    port: "atrasar",
    rus: "задерживать",
    link: "https://www.conjugacao.com.br/verbo-atrasar/",
  },
  {
    port: "mediar",
    rus: "посредничать",
    link: "https://www.conjugacao.com.br/verbo-mediar/",
  },
  {
    port: "despir",
    rus: "раздеваться",
    link: "https://www.conjugacao.com.br/verbo-despir/",
  },
  {
    port: "jantar",
    rus: "ужинать",
    link: "https://www.conjugacao.com.br/verbo-jantar/",
  },
  {
    port: "desenvolver",
    rus: "развивать",
    link: "https://www.conjugacao.com.br/verbo-desenvolver/",
  },
  {
    port: "engolir",
    rus: "глотать",
    link: "https://www.conjugacao.com.br/verbo-engolir/",
  },
  {
    port: "torcer",
    rus: "крутить",
    link: "https://www.conjugacao.com.br/verbo-torcer/",
  },
  {
    port: "formar",
    rus: "формировать",
    link: "https://www.conjugacao.com.br/verbo-formar/",
  },
  {
    port: "obedecer",
    rus: "подчиняться",
    link: "https://www.conjugacao.com.br/verbo-obedecer/",
  },
  {
    port: "trocar",
    rus: "заменять",
    link: "https://www.conjugacao.com.br/verbo-trocar/",
  },
  {
    port: "eleger",
    rus: "Выбирать",
    link: "https://www.conjugacao.com.br/verbo-eleger/",
  },
  {
    port: "retirar",
    rus: "удалять",
    link: "https://www.conjugacao.com.br/verbo-retirar/",
  },
  {
    port: "consumir",
    rus: "потреблять",
    link: "https://www.conjugacao.com.br/verbo-consumir/",
  },
  {
    port: "namorar",
    rus: "влюбиться",
    link: "https://www.conjugacao.com.br/verbo-namorar/",
  },
  {
    port: "moer",
    rus: "молоть",
    link: "https://www.conjugacao.com.br/verbo-moer/",
  },
  {
    port: "impedir",
    rus: "предотвращать",
    link: "https://www.conjugacao.com.br/verbo-impedir/",
  },
  {
    port: "separar",
    rus: "разделять",
    link: "https://www.conjugacao.com.br/verbo-separar/",
  },
  {
    port: "parir",
    rus: "рожать",
    link: "https://www.conjugacao.com.br/verbo-parir/",
  },
  {
    port: "trair",
    rus: "предавать",
    link: "https://www.conjugacao.com.br/verbo-trair/",
  },
  {
    port: "assumir",
    rus: "предполагать",
    link: "https://www.conjugacao.com.br/verbo-assumir/",
  },
  {
    port: "telefonar",
    rus: "звонить",
    link: "https://www.conjugacao.com.br/verbo-telefonar/",
  },
  {
    port: "confiar",
    rus: "доверять",
    link: "https://www.conjugacao.com.br/verbo-confiar/",
  },
  {
    port: "surpreender",
    rus: "удивляться",
    link: "https://www.conjugacao.com.br/verbo-surpreender/",
  },
  {
    port: "lamber",
    rus: "лизать",
    link: "https://www.conjugacao.com.br/verbo-lamber/",
  },
  {
    port: "comparecer",
    rus: "посещать",
    link: "https://www.conjugacao.com.br/verbo-comparecer/",
  },
  {
    port: "substituir",
    rus: "substituir",
    link: "https://www.conjugacao.com.br/verbo-substituir/",
  },
  {
    port: "expressar",
    rus: "выражать",
    link: "https://www.conjugacao.com.br/verbo-expressar/",
  },
  {
    port: "gastar",
    rus: "тратить",
    link: "https://www.conjugacao.com.br/verbo-gastar/",
  },
  {
    port: "juntar",
    rus: "объединить",
    link: "https://www.conjugacao.com.br/verbo-juntar/",
  },
  {
    port: "abster",
    rus: "воздерживаться",
    link: "https://www.conjugacao.com.br/verbo-abster/",
  },
  {
    port: "devolver",
    rus: "возвращать",
    link: "https://www.conjugacao.com.br/verbo-devolver/",
  },
  {
    port: "secar",
    rus: "сушить",
    link: "https://www.conjugacao.com.br/verbo-secar/",
  },
  {
    port: "cobrar",
    rus: "требовать",
    link: "https://www.conjugacao.com.br/verbo-cobrar/",
  },
  {
    port: "orientar",
    rus: "ориентироваться",
    link: "https://www.conjugacao.com.br/verbo-orientar/",
  },
  {
    port: "prestar",
    rus: "оказывать",
    link: "https://www.conjugacao.com.br/verbo-prestar/",
  },
  {
    port: "refazer",
    rus: "переделать",
    link: "https://www.conjugacao.com.br/verbo-refazer/",
  },
  {
    port: "enganar",
    rus: "обмануть",
    link: "https://www.conjugacao.com.br/verbo-enganar/",
  },
  {
    port: "intermediar",
    rus: "посредничать",
    link: "https://www.conjugacao.com.br/verbo-intermediar/",
  },
  {
    port: "orar",
    rus: "молиться",
    link: "https://www.conjugacao.com.br/verbo-orar/",
  },
  {
    port: "comunicar",
    rus: "общаться",
    link: "https://www.conjugacao.com.br/verbo-comunicar/",
  },
  {
    port: "evoluir",
    rus: "развиваться",
    link: "https://www.conjugacao.com.br/verbo-evoluir/",
  },
  {
    port: "evitar",
    rus: "избегать",
    link: "https://www.conjugacao.com.br/verbo-evitar/",
  },
  {
    port: "reconhecer",
    rus: "распознавать",
    link: "https://www.conjugacao.com.br/verbo-reconhecer/",
  },
  {
    port: "prevenir",
    rus: "предотвращать",
    link: "https://www.conjugacao.com.br/verbo-prevenir/",
  },
  {
    port: "agredir",
    rus: "атака",
    link: "https://www.conjugacao.com.br/verbo-agredir/",
  },
  {
    port: "temer",
    rus: "бояться",
    link: "https://www.conjugacao.com.br/verbo-temer/",
  },
  {
    port: "aproximar",
    rus: "приближаться",
    link: "https://www.conjugacao.com.br/verbo-aproximar/",
  },
  {
    port: "aguar",
    rus: "поливать",
    link: "https://www.conjugacao.com.br/verbo-aguar/",
  },
  {
    port: "emprestar",
    rus: "одолжить",
    link: "https://www.conjugacao.com.br/verbo-emprestar/",
  },
  {
    port: "escanear",
    rus: "сканировать",
    link: "https://www.conjugacao.com.br/verbo-escanear/",
  },
  {
    port: "conferir",
    rus: "проверять",
    link: "https://www.conjugacao.com.br/verbo-conferir/",
  },
  {
    port: "prometer",
    rus: "обещать",
    link: "https://www.conjugacao.com.br/verbo-prometer/",
  },
  {
    port: "estrear",
    rus: "дебютировать",
    link: "https://www.conjugacao.com.br/verbo-estrear/",
  },
  {
    port: "puxar",
    rus: "тянуть",
    link: "https://www.conjugacao.com.br/verbo-puxar/",
  },
  {
    port: "cuspir",
    rus: "плевать",
    link: "https://www.conjugacao.com.br/verbo-cuspir/",
  },
  {
    port: "convencer",
    rus: "убедить",
    link: "https://www.conjugacao.com.br/verbo-convencer/",
  },
  {
    port: "frear",
    rus: "тормоз",
    link: "https://www.conjugacao.com.br/verbo-frear/",
  },
  {
    port: "proibir",
    rus: "запретить",
    link: "https://www.conjugacao.com.br/verbo-proibir/",
  },
  {
    port: "definir",
    rus: "определить",
    link: "https://www.conjugacao.com.br/verbo-definir/",
  },
  {
    port: "melhorar",
    rus: "улучшить",
    link: "https://www.conjugacao.com.br/verbo-melhorar/",
  },
  {
    port: "concordar",
    rus: "Соглашаться",
    link: "https://www.conjugacao.com.br/verbo-concordar/",
  },
  {
    port: "cometer",
    rus: "совершить",
    link: "https://www.conjugacao.com.br/verbo-cometer/",
  },
  {
    port: "invadir",
    rus: "вломиться",
    link: "https://www.conjugacao.com.br/verbo-invadir/",
  },
  {
    port: "gemer",
    rus: "стонать",
    link: "https://www.conjugacao.com.br/verbo-gemer/",
  },
  {
    port: "emitir",
    rus: "выдавать",
    link: "https://www.conjugacao.com.br/verbo-emitir/",
  },
  {
    port: "causar",
    rus: "вызывать",
    link: "https://www.conjugacao.com.br/verbo-causar/",
  },
  {
    port: "enjoar",
    rus: "болеть",
    link: "https://www.conjugacao.com.br/verbo-enjoar/",
  },
  {
    port: "advir",
    rus: "приходить",
    link: "https://www.conjugacao.com.br/verbo-advir/",
  },
  {
    port: "auxiliar",
    rus: "помогать",
    link: "https://www.conjugacao.com.br/verbo-auxiliar/",
  },
  {
    port: "animar",
    rus: "анимировать, оживлять",
    link: "https://www.conjugacao.com.br/verbo-animar/",
  },
  {
    port: "comemorar",
    rus: "праздновать",
    link: "https://www.conjugacao.com.br/verbo-comemorar/",
  },
  {
    port: "honrar",
    rus: "почитать, чтить, гордиться",
    link: "https://www.conjugacao.com.br/verbo-honrar/",
  },
  {
    port: "provar",
    rus: "пробовать",
    link: "https://www.conjugacao.com.br/verbo-provar/",
  },
  {
    port: "morder",
    rus: "кусать",
    link: "https://www.conjugacao.com.br/verbo-morder/",
  },
  {
    port: "semear",
    rus: "сеять",
    link: "https://www.conjugacao.com.br/verbo-semear/",
  },
  {
    port: "afastar",
    rus: "отойти",
    link: "https://www.conjugacao.com.br/verbo-afastar/",
  },
  {
    port: "reger",
    rus: "управлять",
    link: "https://www.conjugacao.com.br/verbo-reger/",
  },
  {
    port: "preencher",
    rus: "заполнить",
    link: "https://www.conjugacao.com.br/verbo-preencher/",
  },
  {
    port: "educar",
    rus: "обучать",
    link: "https://www.conjugacao.com.br/verbo-educar/",
  },
  {
    port: "parabenizar",
    rus: "поздравлять",
    link: "https://www.conjugacao.com.br/verbo-parabenizar/",
  },
  {
    port: "gerar",
    rus: "генерировать",
    link: "https://www.conjugacao.com.br/verbo-gerar/",
  },
  {
    port: "retornar",
    rus: "вернуться",
    link: "https://www.conjugacao.com.br/verbo-retornar/",
  },
  {
    port: "abandonar",
    rus: "отказаться",
    link: "https://www.conjugacao.com.br/verbo-abandonar/",
  },
  {
    port: "reclamar",
    rus: "жаловаться",
    link: "https://www.conjugacao.com.br/verbo-reclamar/",
  },
  {
    port: "escovar",
    rus: "чистить",
    link: "https://www.conjugacao.com.br/verbo-escovar/",
  },
  {
    port: "importar",
    rus: "Импортировать",
    link: "https://www.conjugacao.com.br/verbo-importar/",
  },
  {
    port: "completar",
    rus: "завершить",
    link: "https://www.conjugacao.com.br/verbo-completar/",
  },
  {
    port: "atravessar",
    rus: "пройти через",
    link: "https://www.conjugacao.com.br/verbo-atravessar/",
  },
  {
    port: "optar",
    rus: "выбирать",
    link: "https://www.conjugacao.com.br/verbo-optar/",
  },
  {
    port: "infartar",
    rus: "случиться сердечный приступ",
    link: "https://www.conjugacao.com.br/verbo-infartar/",
  },
  {
    port: "distribuir",
    rus: "распростронять",
    link: "https://www.conjugacao.com.br/verbo-distribuir/",
  },
  {
    port: "inserir",
    rus: "вставлять",
    link: "https://www.conjugacao.com.br/verbo-inserir/",
  },
  {
    port: "mover",
    rus: "двигаться",
    link: "https://www.conjugacao.com.br/verbo-mover/",
  },
  {
    port: "gerir",
    rus: "справляться",
    link: "https://www.conjugacao.com.br/verbo-gerir/",
  },
  {
    port: "aplaudir",
    rus: "аплодировать",
    link: "https://www.conjugacao.com.br/verbo-aplaudir/",
  },
  {
    port: "representar",
    rus: "представлять",
    link: "https://www.conjugacao.com.br/verbo-representar/",
  },
  {
    port: "apanhar",
    rus: "ловить, брать",
    link: "https://www.conjugacao.com.br/verbo-apanhar/",
  },
  {
    port: "alegrar",
    rus: "радоваться",
    link: "https://www.conjugacao.com.br/verbo-alegrar/",
  },
  {
    port: "organizar",
    rus: "организовать",
    link: "https://www.conjugacao.com.br/verbo-organizar/",
  },
  {
    port: "banir",
    rus: "запретить",
    link: "https://www.conjugacao.com.br/verbo-banir/",
  },
  {
    port: "coçar",
    rus: "царапать",
    link: "https://www.conjugacao.com.br/verbo-coçar/",
  },
  {
    port: "assinar",
    rus: "подписывать",
    link: "https://www.conjugacao.com.br/verbo-assinar/",
  },
  {
    port: "basear",
    rus: "основываться",
    link: "https://www.conjugacao.com.br/verbo-basear/",
  },
  {
    port: "constituir",
    rus: "составляют",
    link: "https://www.conjugacao.com.br/verbo-constituir/",
  },
  {
    port: "identificar",
    rus: "идентифицировать",
    link: "https://www.conjugacao.com.br/verbo-identificar/",
  },
  {
    port: "perseguir",
    rus: "преследовать",
    link: "https://www.conjugacao.com.br/verbo-perseguir/",
  },
  {
    port: "aplicar",
    rus: "применять",
    link: "https://www.conjugacao.com.br/verbo-aplicar/",
  },
  {
    port: "soltar",
    rus: "выпускать",
    link: "https://www.conjugacao.com.br/verbo-soltar/",
  },
  {
    port: "duvidar",
    rus: "сомневаться",
    link: "https://www.conjugacao.com.br/verbo-duvidar/",
  },
  {
    port: "depor",
    rus: "свидетельствовать",
    link: "https://www.conjugacao.com.br/verbo-depor/",
  },
  {
    port: "pretender",
    rus: "намереваться",
    link: "https://www.conjugacao.com.br/verbo-pretender/",
  },
  {
    port: "treinar",
    rus: "тренировать",
    link: "https://www.conjugacao.com.br/verbo-treinar/",
  },
  {
    port: "demorar",
    rus: "занять время",
    link: "https://www.conjugacao.com.br/verbo-demorar/",
  },
  {
    port: "adicionar",
    rus: "добавить",
    link: "https://www.conjugacao.com.br/verbo-adicionar/",
  },
  {
    port: "apreciar",
    rus: "ценить",
    link: "https://www.conjugacao.com.br/verbo-apreciar/",
  },
  {
    port: "atribuir",
    rus: "назначить",
    link: "https://www.conjugacao.com.br/verbo-atribuir/",
  },
  {
    port: "explodir",
    rus: "взорваться",
    link: "https://www.conjugacao.com.br/verbo-explodir/",
  },
  {
    port: "necessitar",
    rus: "нуждаться",
    link: "https://www.conjugacao.com.br/verbo-necessitar/",
  },
  {
    port: "proporcionar",
    rus: "предоставлять",
    link: "https://www.conjugacao.com.br/verbo-proporcionar/",
  },
  {
    port: "aumentar",
    rus: "увеличивать",
    link: "https://www.conjugacao.com.br/verbo-aumentar/",
  },
  {
    port: "cheirar",
    rus: "чувствовать запах",
    link: "https://www.conjugacao.com.br/verbo-cheirar/",
  },
  {
    port: "confirmar",
    rus: "Подтверждать",
    link: "https://www.conjugacao.com.br/verbo-confirmar/",
  },
  {
    port: "brigar",
    rus: "бороться",
    link: "https://www.conjugacao.com.br/verbo-brigar/",
  },
  {
    port: "carregar",
    rus: "загружать",
    link: "https://www.conjugacao.com.br/verbo-carregar/",
  },
  {
    port: "admirar",
    rus: "восхищаться",
    link: "https://www.conjugacao.com.br/verbo-admirar/",
  },
  {
    port: "superar",
    rus: "преодолеть",
    link: "https://www.conjugacao.com.br/verbo-superar/",
  },
  {
    port: "assar",
    rus: "жарить",
    link: "https://www.conjugacao.com.br/verbo-assar/",
  },
  {
    port: "chatear",
    rus: "расстраиваться",
    link: "https://www.conjugacao.com.br/verbo-chatear/",
  },
  {
    port: "distinguir",
    rus: "различать",
    link: "https://www.conjugacao.com.br/verbo-distinguir/",
  },
  {
    port: "focar",
    rus: "концентрироваться",
    link: "https://www.conjugacao.com.br/verbo-focar/",
  },
  {
    port: "acessar",
    rus: "получить доступ",
    link: "https://www.conjugacao.com.br/verbo-acessar/",
  },
  {
    port: "traduzir",
    rus: "переводить",
    link: "https://www.conjugacao.com.br/verbo-traduzir/",
  },
  {
    port: "queimar",
    rus: "гореть",
    link: "https://www.conjugacao.com.br/verbo-queimar/",
  },
  {
    port: "desaparecer",
    rus: "исчезать",
    link: "https://www.conjugacao.com.br/verbo-desaparecer/",
  },
  {
    port: "recear",
    rus: "бояться",
    link: "https://www.conjugacao.com.br/verbo-recear/",
  },
  {
    port: "saudar",
    rus: "приветствовать",
    link: "https://www.conjugacao.com.br/verbo-saudar/",
  },
  {
    port: "investir",
    rus: "вкладывать деньги",
    link: "https://www.conjugacao.com.br/verbo-investir/",
  },
  {
    port: "latir",
    rus: "лаять",
    link: "https://www.conjugacao.com.br/verbo-latir/",
  },
  {
    port: "saborear",
    rus: "смаковать",
    link: "https://www.conjugacao.com.br/verbo-saborear/",
  },
  {
    port: "banhar",
    rus: "купаться",
    link: "https://www.conjugacao.com.br/verbo-banhar/",
  },
  {
    port: "fumar",
    rus: "курить",
    link: "https://www.conjugacao.com.br/verbo-fumar/",
  },
  {
    port: "costumar",
    rus: "что-то делать обычто",
    link: "https://www.conjugacao.com.br/verbo-costumar/",
  },
  {
    port: "anunciar",
    rus: "объявлять",
    link: "https://www.conjugacao.com.br/verbo-anunciar/",
  },
  {
    port: "verificar",
    rus: "проверять",
    link: "https://www.conjugacao.com.br/verbo-verificar/",
  },
  {
    port: "arranjar",
    rus: "организовывать",
    link: "https://www.conjugacao.com.br/verbo-arranjar/",
  },
  {
    port: "combinar",
    rus: "подбирать",
    link: "https://www.conjugacao.com.br/verbo-combinar/",
  },
  {
    port: "louvar",
    rus: "хвалить",
    link: "https://www.conjugacao.com.br/verbo-louvar/",
  },
  {
    port: "ignorar",
    rus: "игнорировать",
    link: "https://www.conjugacao.com.br/verbo-ignorar/",
  },
  {
    port: "aquecer",
    rus: "нагревать",
    link: "https://www.conjugacao.com.br/verbo-aquecer/",
  },
];
